import React, { createContext, useContext, useState } from 'react';

const HasCheckedContext = createContext(undefined);

export const useHasChecked = () => {
  const context = useContext(HasCheckedContext);
  if (!context) {
    throw new Error('useHasChecked must be used within a HasCheckedProvider');
  }
  return context;
};



const HasCheckedProvider = ({ children }) => {
  const [hasChecked, setHasChecked] = useState(false);

  return (
    <HasCheckedContext.Provider value={{ hasChecked, setHasChecked }}>
      {children}
    </HasCheckedContext.Provider>
  );
};

export default HasCheckedProvider;
